<template>
  <div>
    <a-progress
      :percent="progress.progress_percent"
      :status="progress.progress_status"
      :format="(percent, successPercent)=>handleProgressFormat(percent, successPercent)"
    />
  </div>
</template>

<script>
export default {
  props: {
    status: null
  },
  data() {
    return {
      cases: {
        '0': {
          progress_text: '等待审核',
          progress_percent: 50,
          progress_status: 'active'
        },
        '2': {
          progress_text: '拒绝并返还',
          progress_percent: 100,
          progress_status: 'exception'
        },
        '3': {
          progress_text: '拒绝并扣除',
          progress_percent: 100,
          progress_status: 'exception'
        },
        '1': {
          progress_text: '提现完成',
          progress_percent: 100,
          progress_status: 'success'
        },
        '4': {
          progress_text: '任务奖励',
          progress_percent: 100,
          progress_status: 'active'
        }
      }
    }
  },
  computed: {
    progress(newVal) {
        const status = newVal.status
        return this.cases[status]
    }
  },
  methods: {
    handleProgressFormat(percent, successPercent) {
      return this.progress.progress_text
    }
  }
}
</script>
